import { Component, ChangeDetectionStrategy, Type } from '@angular/core';
import { FieldTypeConfig, FormlyFieldConfig, FormlyFieldProps } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/core';

interface ColorPickerProps extends FormlyFieldProps {
  /**
   * One compact control: the swatch moves INSIDE the field border and becomes the picker
   * trigger, and the hex box narrows to the width of a hex value. Opt-in so the wide
   * two-element form stays whatever it was wherever it is still used. (CHAT-995)
   */
  compact?: boolean;
  showPreview?: boolean;
  colorPickerPosition?: string;
  colorPickerOutputFormat?: string;
  colorPickerAlphaChannel?: string;
}

export interface FormlyColorPickerFieldConfig extends FormlyFieldConfig<ColorPickerProps> {
  type: 'color-picker' | Type<FormlyFieldColorPicker>;
}

@Component({
  standalone: false,
  selector: 'formly-field-color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldColorPicker extends FieldType<FieldTypeConfig<ColorPickerProps>> {
  override defaultOptions = {
    props: {
      showPreview: true,
      colorPickerPosition: 'right',
      colorPickerOutputFormat: 'hex',
      colorPickerAlphaChannel: 'disabled'
    },
  };

  onColorChange(color: string) {
    this.formControl.setValue(color);
    this.formControl.markAsDirty();
  }
}
